import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import VerbSelect from '../../../../shared/components/formComponents/inputs/VerbSelect';
import { LEARNING_ASSET_TYPE_OBJECT } from '../../../../shared/Constants';

class LearningAssetTableSearchFilter extends PureComponent {
    static propTypes = {
        algoliaSearch: PropTypes.PropTypes.shape({
            filters: PropTypes.object,
            query: PropTypes.string
        }),
        updateAlgoliaSearchFilters: PropTypes.func,
        postAlgoliaSearch: PropTypes.func,
        algoliaIndex: PropTypes.string,
        clearAlgoliaSearchResult: PropTypes.func,
        isVerbAdmin: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {
            filters: {}
        };
        this.createdByTypesDict = {
            CREATED_BY_VERB: {
                id: 'CREATED_BY_VERB',
                label: 'Created by Verb'
            },
            CREATED_BY_CUSTOMER: {
                id: 'CREATED_BY_CUSTOMER',
                label: 'Created by Customer'
            },
            CREATED_BY_THIRD_PARTY: {
                id: 'CREATED_BY_THIRD_PARTY',
                label: 'Created by Third Party '
            }
        };
        this.isActiveDict = {
            true: {
                id: true,
                label: 'Active'
            },
            false: {
                id: false,
                label: 'Not Active'
            }
        };
        this.assetTypesDict = {
            ...LEARNING_ASSET_TYPE_OBJECT,
            SINGLE_PAGE_ACTIVITY: {
                id: 'SINGLE_PAGE_ACTIVITY',
                label: 'Single Page Activity',
                label_plural: 'Single Page Activities'
            }
        };
        delete this.assetTypesDict.WELCOME;

        this.dictionariesByFilterField = {
            isActive: this.isActiveDict,
            type: this.assetTypesDict,
            createdBy: this.createdByTypesDict
        };
    }

    _toggleSearchFilter = (field, filterValue) => {
        const {
            algoliaSearch = {},
            updateAlgoliaSearchFilters,
            postAlgoliaSearch,
            algoliaIndex,
            clearAlgoliaSearchResult
        } = this.props;
        const newFilters = {
            ...algoliaSearch.filters
        };
        if (filterValue === undefined) {
            delete newFilters[field];
        } else if (algoliaSearch.filters[field] && algoliaSearch.filters[field][filterValue]) {
            delete newFilters[field][filterValue];
            if (isEmpty(newFilters[field])) {
                delete newFilters[field];
            }
        } else if (!newFilters[field] || !newFilters[field][filterValue]) {
            newFilters[field] = {
                ...newFilters[field],
                [filterValue]: {
                    isApplied: true,
                    type: 'INCLUDE'
                }
            };
        }

        // async
        updateAlgoliaSearchFilters(newFilters);

        this.setState({
            filters: newFilters
        });

        if (isEmpty(newFilters) && !algoliaSearch.query) {
            return clearAlgoliaSearchResult();
        }
        return postAlgoliaSearch(algoliaSearch.query, algoliaIndex, newFilters);
    };

    _getFilterValue = (field) => {
        const currentFilterObject = this.state.filters[field] || {};

        return Object.keys(currentFilterObject).map((filterValue) => ({
            id: filterValue,
            label: this.dictionariesByFilterField[field][filterValue].label
        }));
    };

    _handleFilterOnChange = (field, value, changeEvent) => {
        if (changeEvent.action === 'remove-value') {
            return this._toggleSearchFilter(field, changeEvent.removedValue.id);
        }
        if (changeEvent.action === 'clear') {
            return this._toggleSearchFilter(field, undefined);
        }

        return this._toggleSearchFilter(field, value[value.length - 1].id);
    };

    render() {
        const { isVerbAdmin } = this.props;
        return (
            <div className={'learning-asset-table-filter'}>
                <div className={'row'}>
                    <p>FILTER BY</p>
                </div>
                <div className={'row'}>
                    {isVerbAdmin && (
                        <VerbSelect
                            value={this._getFilterValue('createdBy')}
                            labelKey={'label'}
                            valueKey={'id'}
                            isMulti={true}
                            onChange={(value, changeEvent) => {
                                this._handleFilterOnChange('createdBy', value, changeEvent);
                            }}
                            options={Object.values(this.createdByTypesDict)}
                            className={'col-12'}
                            placeholder={'Created By'}
                            styleProps={'col-3'}
                        />
                    )}
                    <VerbSelect
                        value={this._getFilterValue('isActive')}
                        labelKey={'label'}
                        valueKey={'id'}
                        isMulti={true}
                        onChange={(value, changeEvent) => {
                            this._handleFilterOnChange('isActive', value, changeEvent);
                        }}
                        options={Object.values(this.isActiveDict)}
                        className={'col-12'}
                        placeholder={'Is Active'}
                        styleProps={'col-3'}
                    />
                    <VerbSelect
                        value={this._getFilterValue('type')}
                        labelKey={'label'}
                        valueKey={'id'}
                        isMulti={true}
                        onChange={(value, changeEvent) => {
                            this._handleFilterOnChange('type', value, changeEvent);
                        }}
                        options={Object.values(this.assetTypesDict)}
                        className={'col-12'}
                        placeholder={'Type'}
                        styleProps={'col-3'}
                    />
                </div>
            </div>
        );
    }
}

export default LearningAssetTableSearchFilter;
